const Apis = { default: 'api' };
//-- account -------------------------------------------------------------------
Apis.account = { default: Apis.default + '/account' };
Apis.account.login = Apis.account.default + '/login';
Apis.account.userData = Apis.account.default + '/user-data';
//-- artists -------------------------------------------------------------------
Apis.artists = { default: Apis.default + '/artists' };
Apis.artists.create = Apis.artists.default + '/create';
Apis.artists.search = Apis.artists.default + '/search';
//-- label -------------------------------------------------------------------
Apis.label = { default: Apis.default + '/parameters' };
Apis.label.create = Apis.label.default + '/label';
//-- boxes -------------------------------------------------------------------
Apis.boxes = { default: Apis.default + '/boxes' };
Apis.boxes.search = Apis.boxes.default + '/list';
Apis.boxes.details = Apis.boxes.default + '/Details';
Apis.boxes.duplicate = Apis.boxes.default + '/Duplicate';
Apis.boxes.edit = Apis.boxes.default + '/Edit';
Apis.boxes.create = Apis.boxes.default + '/Create';
Apis.boxes.updateFilters = Apis.boxes.default + '/update-filters';
Apis.boxes.trackList = Apis.boxes.default + '/track-list';
Apis.boxes.similarTracks = Apis.boxes.default + '/similar-tracks';
Apis.boxes.linkTrack = Apis.boxes.default + '/link-track';
Apis.boxes.linkTracks = Apis.boxes.default + '/link-tracks';
Apis.boxes.unlinkTrack = Apis.boxes.default + '/unlink-track';
Apis.boxes.unlinkTracks = Apis.boxes.default + '/unlink-tracks';
Apis.boxes.moveTrack = Apis.boxes.default + '/move-track';
Apis.boxes.moveTracks = Apis.boxes.default + '/move-tracks';
Apis.boxes.remove = Apis.boxes.default + '/remove';
Apis.boxes.removalData = Apis.boxes.default + '/removal-data';

//-- clocks -------------------------------------------------------------------
Apis.clocks = { default: Apis.default + '/clocks' };
Apis.clocks.list = Apis.clocks.default + '/list';
Apis.clocks.details = Apis.clocks.default + '/Details';
Apis.clocks.boxList = Apis.clocks.default + '/box-list';
Apis.clocks.create = Apis.clocks.default + '/Create';
Apis.clocks.edit = Apis.clocks.default + '/Edit';
Apis.clocks.linkBox = Apis.clocks.default + '/link-box';
Apis.clocks.unlinkBox = Apis.clocks.default + '/unlink-box';
Apis.clocks.moveBox = Apis.clocks.default + '/move-box';
Apis.clocks.removalData = Apis.clocks.default + '/removal-data';
Apis.clocks.remove = Apis.clocks.default + '/remove';
Apis.clocks.duplicate = Apis.clocks.default + '/Duplicate';
Apis.clocks.stats = Apis.clocks.default + '/stats';
Apis.clocks.updateBoxFilters = Apis.clocks.default + '/clock-box/update-filters';
//-- daytemplates -------------------------------------------------------------------
Apis.daytemplates = { default: Apis.default + '/daytemplates' };
Apis.daytemplates.search = Apis.daytemplates.default + '/Search';
Apis.daytemplates.details = Apis.daytemplates.default + '/Details';
Apis.daytemplates.adBreaks = Apis.daytemplates.default + '/ad-breaks';
Apis.daytemplates.create = Apis.daytemplates.default + '/Create';
Apis.daytemplates.remove = Apis.daytemplates.default + '/remove';
Apis.daytemplates.duplicate = Apis.daytemplates.default + '/Duplicate';
Apis.daytemplates.edit = Apis.daytemplates.default + '/Edit';
Apis.daytemplates.scheduledItems = Apis.daytemplates.default + '/scheduled-items';
Apis.daytemplates.linkClock = Apis.daytemplates.default + '/link-clock';
Apis.daytemplates.linkPlaylist = Apis.daytemplates.default + '/link-playlist';
Apis.daytemplates.linkPodcast = Apis.daytemplates.default + '/link-podcast';
Apis.daytemplates.linkPromo = Apis.daytemplates.default + '/link-promo';
Apis.daytemplates.unlinkItem = Apis.daytemplates.default + '/unlink-item';
Apis.daytemplates.removalData = Apis.daytemplates.default + '/removal-data';
//-- Week template -------------------------------------------------------------------
Apis.weektemplates = { default: Apis.default + '/week-templates' };
Apis.weektemplates.list = Apis.weektemplates.default + '/list';
Apis.weektemplates.create = Apis.weektemplates.default + '/create';
//-- library -------------------------------------------------------------------
Apis.library = { default: Apis.default + '/library' };
Apis.library.uploadCallback = Apis.library.default + '/upload-callback';
Apis.library.tracks = { default: Apis.library.default + '/tracks' };
Apis.library.tracks.removalData = Apis.library.tracks.default + '/removal-data';
Apis.library.tracks.playToken = Apis.library.tracks.default + '/play-token';
Apis.library.tracks.play = Apis.library.tracks.default + '/play';
Apis.library.tracks.dashboardstats = Apis.library.tracks.default + '/dashboardstats';
Apis.library.tracks.details = Apis.library.tracks.default + '/details';
Apis.library.tracks.pending = Apis.library.tracks.default + '/pending';
Apis.library.tracks.uncompleted = Apis.library.tracks.default + '/uncomplete';
Apis.library.tracks.search = Apis.library.tracks.default + '/search';
Apis.library.tracks.advancedSearch = Apis.library.tracks.default + '/advanced-search';
Apis.library.tracks.update = { default: Apis.library.tracks.default + '/update' };
Apis.library.tracks.update.artist = Apis.library.tracks.update.default + '/author';
Apis.library.tracks.update.artists = Apis.library.tracks.update.default + '/artists';
Apis.library.tracks.update.label = Apis.library.tracks.update.default + '/label';
Apis.library.tracks.update.languages = Apis.library.tracks.update.default + '/languages';
Apis.library.tracks.update.isExplicit = Apis.library.tracks.update.default + '/isexplicit';
Apis.library.tracks.update.styles = Apis.library.tracks.update.default + '/styles';
Apis.library.tracks.update.description = Apis.library.tracks.update.default + '/description';
Apis.library.tracks.update.tags = Apis.library.tracks.update.default + '/tags';
Apis.library.tracks.update.title = Apis.library.tracks.update.default + '/title';
Apis.library.tracks.update.mixDemo = Apis.library.tracks.update.default + '/mix-demo';
Apis.library.tracks.update.bpm = Apis.library.tracks.update.default + '/bpm';
Apis.library.tracks.update.mood = Apis.library.tracks.update.default + '/mood';
Apis.library.tracks.update.year = Apis.library.tracks.update.default + '/year';
Apis.library.tracks.update.validate = Apis.library.tracks.update.default + '/validate';
Apis.library.tracks.update.genderId = Apis.library.tracks.update.default + '/genderId';
Apis.library.tracks.update.energy = Apis.library.tracks.update.default + '/energy';
Apis.library.tracks.update.remove = Apis.library.tracks.update.default + '/remove';
Apis.library.tracks.update.mixPointers = Apis.library.tracks.update.default + '/mix-pointers';
Apis.library.tracks.update.instruments =  Apis.library.tracks.update.default + '/targets';
Apis.library.upload = Apis.library.default + '/upload';
Apis.library.massUpload = Apis.library.default + '/upload-bulk';
Apis.library.statistics = Apis.library.default + '/statistics';
//-- parameters -------------------------------------------------------------------
Apis.parameters = { default: Apis.default + '/parameters' };
Apis.parameters.styles = Apis.parameters.default + '/styles';
Apis.parameters.style = Apis.parameters.default + '/style';
Apis.parameters.labels = Apis.parameters.default + '/labels';
Apis.parameters.tags = Apis.parameters.default + '/tags';
Apis.parameters.languages = Apis.parameters.default + '/languages';
Apis.parameters.categories =  Apis.parameters.default  + '/categories';
Apis.parameters.targets =  Apis.parameters.default  + '/targets';

//-- planning -------------------------------------------------------------------
Apis.planning = { default: Apis.default + '/planning' };
Apis.planning.list = Apis.planning.default + '/list';
Apis.planning.details = Apis.planning.default + '/details';
Apis.planning.schedule = Apis.planning.default + '/schedule';
Apis.planning.scheduleBatch = Apis.planning.default + '/schedule-batch';
//-- station -------------------------------------------------------------------
Apis.station = { default: Apis.default + '/station' };
Apis.station.list = Apis.station.default + '/list';
Apis.station.dashboard = Apis.station.default + '/dashboard';
Apis.station.contentUpdate = Apis.station.default + '/ContentUpdate';
Apis.station.lock = Apis.station.default + '/lock-status';
//-- timeConstraints -------------------------------------------------------------------
Apis.timeConstraints = { default:Apis.default + '/timeConstraints' };
Apis.timeConstraints.list = { default:Apis.timeConstraints.default + '/list' };
Apis.timeConstraints.list.track = Apis.timeConstraints.list.default + '/track';
Apis.timeConstraints.list.box = Apis.timeConstraints.list.default + '/box';
Apis.timeConstraints.list.clock = Apis.timeConstraints.list.default + '/clock';
Apis.timeConstraints.list.dayTemplate = Apis.timeConstraints.list.default + '/day-template';
Apis.timeConstraints.add = Apis.timeConstraints.default + '/add';
Apis.timeConstraints.delete = Apis.timeConstraints.default + '/delete';
Apis.timeConstraints.edit = { default:Apis.timeConstraints.default + '/edit' };
Apis.timeConstraints.edit.box = Apis.timeConstraints.edit.default + '/box';
Apis.timeConstraints.edit.dayTemplate = Apis.timeConstraints.edit.default + '/day-template';
Apis.timeConstraints.edit.clock = Apis.timeConstraints.edit.default + '/clock';
Apis.timeConstraints.edit.track = Apis.timeConstraints.edit.default + '/track';
export default Apis
